import React from "react";
import { useSiteSettings } from "@brz-utils/use.site.settings";
import { usePage } from "@brz-utils/contexts/page.context";



export const OrgSchema = () => {
    const site = useSiteSettings();
    const { page, template } = usePage();

    if (template.disable?.orgSchema || page.seo.org?.disable) return null;

    const jsonObj = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": site.name,
        "legalName": site.legalName,
        "areaServed": "United States",
        "url": site.baseUrl,
        "logo": {
            "@type": "ImageObject",
            "url": site.logo.src,
            "width": site.logo.width,
            "height": site.logo.height
        },
        "knowsAbout": "Insurance",
        "foundingDate": site.foundingDate,
        ...(site.founders?.length ? {
            "founder": site.founders?.map(person => {
                return {
                    "@type": "Person",
                    "name": person.name,
                    "sameAs": person.socialLink,
                    "jobTitle": person.occupation,
                    "worksFor": site.name
                }
            })
        } : {}),
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": site.rating.value,
            "bestRating": site.rating.outOf,
            "reviewCount": site.rating.reviews
        },
        "address": {
            "@type": "PostalAddress",
            "streetAddress": site.businessAddress.street,
            "addressLocality": site.businessAddress.city,
            "addressRegion": site.businessAddress.state,
            "postalCode": site.businessAddress.zip,
            "addressCountry": "USA"
        },
        "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "Licensed Advisor",
            "telephone": `[1 ${site.phone}]`,
            "email": site.email
        },
        "sameAs": site.socialLinks
    };

    return (
        <script id="org-schema" type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonObj, null, '  ') }} />
    );
};